import React, { useMemo } from "react";
import { Text, View, TouchableOpacity, Image, Platform } from "react-native";
import StyleSheet from "react-native-media-query";
import commonStyle from "../../assets/styles/common-style";
import { PDF_FILE_ICON } from "../../resources/IMAGES";
import { documentNameFormatter } from "@lib/utilities/Formatters";
import { theme } from "../../theme/theme";
import _ from "lodash";

const DocumentListItem = (props: any) => {
  let documentDetails = props.documentDetails;
  const handleThrottledTap = (_.throttle(props.onItemPress, 500, {
      leading: true,
      trailing: false,
    }))

  return (
    <TouchableOpacity
      onPress={handleThrottledTap}
      style={{ width: 280 }}
      testID={`docs-page-document-item-${props.index}`}
    >
      <View
        style={[
          styles.documentCard,
          commonStyle.styles.rowFlex,
          commonStyle.styles.inMiddle,
        ]}
        dataSet={{ media: ids.documentCard }}
      >
        {Platform.OS == "web" ? (
          <Image style={styles.fileIcon} source={PDF_FILE_ICON} />
        ) : (
          <Image style={styles.fileIcon} source={PDF_FILE_ICON} />
        )}
        <View
          style={[commonStyle.styles.colFlex, styles.documentInfo]}
          dataSet={{ media: commonStyle.ids.colFlex }}
        >
          <Text
            numberOfLines={3}
            ellipsizeMode="middle"
            style={[styles.docName]}
            dataSet={{ media: ids.docName }}
            testID={`docs-page-document-item-${props.index}`}
          >
            {documentNameFormatter(documentDetails.fileName)}
          </Text>
        </View>
        {Platform.OS == "web" ? (
          <Image style={styles.fileIconBg} source={PDF_FILE_ICON} />
        ) : (
          <Image style={styles.fileIconBg} source={PDF_FILE_ICON} />
        )}
      </View>
    </TouchableOpacity>
  );
};

// Define your styles
const { ids, styles } = StyleSheet.create({
  docTitle: {
    fontFamily: "Roboto Slab",
    fontSize: 18,
    marginBottom: 5,
    fontWeight: "400",
    color: theme.colors.white,
    ...Platform.select({
      ios: {
        fontFamily: "RobotoSlab-Regular",
      },
      android: {
        fontFamily: "RobotoSlab-Regular",
      },
      web: {
        "@media (min-width: 200px)": {
          fontSize: 16,
          color: theme.colors.white,
        },
        "@media (min-width: 385px)": {
          fontSize: 20,
          color: theme.colors.white,
        },
        "@media (min-width: 700px)": {
          fontSize: 22,
          color: theme.colors.white,
        },
        "@media (min-width: 1000px)": {
          fontSize: 20,
        },
      },
    }),
  },
  documentCard: {
    minHeight: 80,
    borderRadius: 13,
    backgroundColor: theme.colors.white + 20,

    borderStyle: "solid",
    borderWidth: 2,
    borderColor: theme.colors.white,
    padding: 16,
    marginRight: 12,
    marginLeft: 6,
    maxHeight:80
  },
  docName: {
    color: theme.colors.white,
    fontFamily: theme.fontFamily.robotoSlabRegular,
    maxWidth: "80%",
    ...Platform.select({
      ios: {
        fontSize: 15,
      },
      android: {
        fontSize: 13,
      },
      web: {
        "@media (min-width: 200px)": {
          fontSize: 16,
          color: theme.colors.white,
        },
        "@media (min-width: 385px)": {
          fontSize: 18,
          color: theme.colors.white,
        },
        "@media (min-width: 700px)": {
          fontSize: 16,
          color: theme.colors.white,
        },
        "@media (min-width: 1000px)": {
          fontSize: 18,
        },
      },
    }),
  },
  documentInfo: {
    marginLeft: 10,
    width: 190,
  },

  fileIcon: {
    width: 40,
    height: 52,
  },
  fileIconBg: {
    width: 40,
    height: 52,
    opacity: 0.1,
    position: "absolute",
    right: 10,
    transform: [{ rotate: "-14deg" }],
  },
});

export default DocumentListItem;
